import {Box, IconButton, useTheme} from '@mui/material';
import {useTranslation} from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
interface ImagePreviewBoxProps {
  url: string;
  index: number;
  onPreviewClose: (index: number) => void;
}

const ImagePreviewBox: React.FC<ImagePreviewBoxProps> = ({
  url,
  index,
  onPreviewClose
}) => {
  const {t} = useTranslation();
  const theme = useTheme();

  return (
    <Box
      key={url}
      sx={{
        position: 'relative',
        width: {xs: '70px', lg: '120px'},
        height: {xs: '70px', lg: '120px'},
        marginTop: 5,
        marginBottom: 5,
        flexShrink: 0
      }}
    >
      <img
        src={url}
        alt={`${t('preview')} ${index + 1}`}
        style={{width: '100%', height: '100%', objectFit: 'cover'}}
      />
      <IconButton
        edge="end"
        color="inherit"
        onClick={() => onPreviewClose(index)}
        aria-label={t('close')}
        sx={{
          position: 'absolute',
          right: 5,
          top: 0,
          color: theme.palette.primary.contrastText
        }}
      >
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default ImagePreviewBox;
